import { render, staticRenderFns } from "./lawcomponenttw.vue?vue&type=template&id=7a729f6e&scoped=true&"
import script from "./lawcomponenttw.vue?vue&type=script&lang=js&"
export * from "./lawcomponenttw.vue?vue&type=script&lang=js&"
import style0 from "./lawcomponenttw.vue?vue&type=style&index=0&id=7a729f6e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a729f6e",
  null
  
)

export default component.exports